"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ChatTranslate: ['chat-translate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,4.25A.751.751,0,0,0,5.75,5v.5A.25.25,0,0,0,6,5.75H7a.25.25,0,0,0,.25-.25V5A.751.751,0,0,0,6.5,4.25Z', 'M17.223,17.25a.25.25,0,0,0-.234.339,3.975,3.975,0,0,0,.3.614.249.249,0,0,0,.43,0,4.058,4.058,0,0,0,.3-.614.25.25,0,0,0-.234-.339Z', 'M22.5,11H14.75a.25.25,0,0,0-.25.25v2.5a.75.75,0,0,1-.75.75h-3a.25.25,0,0,0-.25.25V22.5A1.5,1.5,0,0,0,12,24H22.5A1.5,1.5,0,0,0,24,22.5v-10A1.5,1.5,0,0,0,22.5,11Zm-8,4.75h2a.25.25,0,0,0,.25-.25V15a.75.75,0,0,1,1.5,0v.5a.25.25,0,0,0,.25.25h2a.75.75,0,0,1,0,1.5h-.627a.249.249,0,0,0-.243.192,5.51,5.51,0,0,1-.876,1.905.249.249,0,0,0-.041.2.246.246,0,0,0,.118.163,5.881,5.881,0,0,0,1.372.57.75.75,0,1,1-.406,1.444,7.057,7.057,0,0,1-2.153-1,.248.248,0,0,0-.287,0,7.057,7.057,0,0,1-2.153,1,.75.75,0,1,1-.406-1.444,5.881,5.881,0,0,0,1.372-.57.25.25,0,0,0,.119-.163.253.253,0,0,0-.042-.2,5.51,5.51,0,0,1-.876-1.905.249.249,0,0,0-.243-.192H14.5a.75.75,0,0,1,0-1.5Z', 'M12.75,13a.25.25,0,0,0,.25-.25V1.5A1.5,1.5,0,0,0,11.5,0H1.5A1.5,1.5,0,0,0,0,1.5v10A1.5,1.5,0,0,0,1.5,13ZM6,7.25a.25.25,0,0,0-.25.25v2a.75.75,0,0,1-1.5,0V5a2.25,2.25,0,0,1,4.5,0V9.5a.75.75,0,0,1-1.5,0v-2A.25.25,0,0,0,7,7.25Z']],
  SpeechTranslate: ['speech-translate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.326,4.25a5.458,5.458,0,0,0-5.4,5.5,1,1,0,1,0,2,0,3.456,3.456,0,0,1,3.4-3.5,1,1,0,0,0,0-2Z', 'M9.315,2.25a1,1,0,0,0,0-2A9.42,9.42,0,0,0,0,9.75a1,1,0,0,0,2,0A7.417,7.417,0,0,1,9.315,2.25Z', 'M18.076,9.75a1,1,0,0,0,2,0,5.458,5.458,0,0,0-5.4-5.5,1,1,0,0,0,0,2A3.456,3.456,0,0,1,18.076,9.75Z', 'M14.685.25a1,1,0,0,0,0,2A7.417,7.417,0,0,1,22,9.75a1,1,0,0,0,2,0A9.42,9.42,0,0,0,14.685.25Z', 'M21.5,22.75a1,1,0,0,0-1-1H19.338a.252.252,0,0,1-.232-.155L13.39,7.687a1.5,1.5,0,0,0-2.778-.006L4.894,21.6a.252.252,0,0,1-.232.155H3.5a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2H7.365a.251.251,0,0,1-.231-.345L8.5,18.076a.25.25,0,0,1,.231-.155h6.534a.25.25,0,0,1,.231.155l1.368,3.329a.251.251,0,0,1-.231.345H16.5a1,1,0,0,0,0,2h4A1,1,0,0,0,21.5,22.75ZM9.761,15.921a.25.25,0,0,1-.231-.345L12,9.566l2.47,6.01a.25.25,0,0,1-.231.345Z']],
  Translate: ['translate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,1A1,1,0,0,0,6,1V7A1,1,0,0,0,8,7Z', 'M21.5,16A2.5,2.5,0,0,0,19,18.5V23a1,1,0,0,0,2,0V21.25a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25V23a1,1,0,0,0,2,0V18.5A2.5,2.5,0,0,0,21.5,16Zm-.25,3a.25.25,0,0,1-.25-.25V18.5a.5.5,0,0,1,1,0v.25a.25.25,0,0,1-.25.25Z', 'M10.5,16A2.5,2.5,0,0,0,8,18.5v3a2.5,2.5,0,0,0,5,0v-3A2.5,2.5,0,0,0,10.5,16Zm.5,5.5a.5.5,0,0,1-1,0v-3a.5.5,0,0,1,1,0Z', 'M17.5,22H15.75a.25.25,0,0,1-.25-.25V17a1,1,0,0,0-2,0v5a2,2,0,0,0,2,2h2a1,1,0,0,0,0-2Z', 'M1,8A1,1,0,0,0,2,7V5.25A.25.25,0,0,1,2.25,5h.5A.25.25,0,0,1,3,5.25V7A1,1,0,0,0,5,7V1A1,1,0,0,0,3,1V2.75A.25.25,0,0,1,2.75,3h-.5A.25.25,0,0,1,2,2.75V1A1,1,0,0,0,0,1V7A1,1,0,0,0,1,8Z', 'M6.5,16a1,1,0,0,0-1,1v1.75a.25.25,0,0,1-.25.25h-.5a.25.25,0,0,1-.25-.25V17a1,1,0,0,0-2,0v6a1,1,0,0,0,2,0V21.25A.25.25,0,0,1,4.75,21h.5a.25.25,0,0,1,.25.25V23a1,1,0,0,0,2,0V17A1,1,0,0,0,6.5,16Z', 'M2.846,15.014a1,1,0,1,0,1.73-1,12.3,12.3,0,0,1-.915-1.67.249.249,0,0,1,.027-.232A.253.253,0,0,1,3.894,12H4.5a.5.5,0,0,0,.354-.854l-2-2a.5.5,0,0,0-.708,0l-2,2A.5.5,0,0,0,.5,12h.8a.251.251,0,0,1,.243.191A11.089,11.089,0,0,0,2.846,15.014Z', 'M10.5,2.215a1,1,0,0,0,1,1,8.065,8.065,0,0,1,7.151,4.422A.25.25,0,0,1,18.429,8H17.5a.5.5,0,0,0-.354.853l3,3A.5.5,0,0,0,20.5,12h.022a.5.5,0,0,0,.362-.179l2.5-3A.5.5,0,0,0,23,8H21.145a.25.25,0,0,1-.235-.165,10.083,10.083,0,0,0-9.41-6.62A1,1,0,0,0,10.5,2.215Z']],
  PhoneTranslate: ['phone-translate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.5,3.5A.5.5,0,0,1,6,3H17a.5.5,0,0,1,.5.5v.75a.25.25,0,0,0,.25.25h1.5a.25.25,0,0,0,.25-.25V3a3,3,0,0,0-3-3H6.5a3,3,0,0,0-3,3V4.25a.25.25,0,0,0,.25.25h1.5a.25.25,0,0,0,.25-.25Z', 'M17.5,19a.5.5,0,0,1-.5.5H6a.5.5,0,0,1-.5-.5V17.5h-2V21a3,3,0,0,0,3,3h10a3,3,0,0,0,3-3V17.75a.25.25,0,0,0-.25-.25h-1.5a.25.25,0,0,0-.25.25Z', 'M23.25,9.5a.752.752,0,0,0-.75-.75h-2a.25.25,0,0,1-.25-.25v-1a.75.75,0,0,0-1.5,0v1a.25.25,0,0,1-.25.25h-2a.75.75,0,0,0,0,1.5h.134a.249.249,0,0,1,.242.189,5.311,5.311,0,0,0,1.108,2.121.252.252,0,0,1,.051.224.248.248,0,0,1-.152.171,7.309,7.309,0,0,1-1.047.313.75.75,0,0,0,.326,1.464,7.954,7.954,0,0,0,2.214-.829.248.248,0,0,1,.247,0,7.986,7.986,0,0,0,2.214.829.75.75,0,0,0,.326-1.464,7.309,7.309,0,0,1-1.047-.313.248.248,0,0,1-.152-.171.252.252,0,0,1,.051-.224,5.311,5.311,0,0,0,1.108-2.121.249.249,0,0,1,.242-.189H22.5a.752.752,0,0,0,.75-.75Zm-3.571,2.31a.25.25,0,0,1-.359,0,3.893,3.893,0,0,1-.807-1.213.251.251,0,0,1,.023-.235.248.248,0,0,1,.208-.112h1.511a.253.253,0,0,1,.208.111.249.249,0,0,1,.022.235A3.88,3.88,0,0,1,19.679,11.81Z', 'M8.884,8.621A.75.75,0,1,0,8.116,9.91a1.25,1.25,0,0,1,0,2.15.75.75,0,0,0,.77,1.288,2.751,2.751,0,0,0,0-4.727Z', 'M11.635,5.916a.75.75,0,1,0-.879,1.216,4.749,4.749,0,0,1,.261,7.5.75.75,0,0,0,.961,1.153,6.251,6.251,0,0,0-.343-9.872Z', 'M3,7.749A2.253,2.253,0,0,0,.75,10v4.5a.75.75,0,0,0,1.5,0v-2a.25.25,0,0,1,.25-.25h1a.25.25,0,0,1,.25.25v2a.75.75,0,1,0,1.5,0V10A2.253,2.253,0,0,0,3,7.749Zm-.5,3a.249.249,0,0,1-.25-.25V10a.75.75,0,0,1,1.5,0v.5a.249.249,0,0,1-.25.25Z']],
  SpeechTranslate1: ['speech-translate-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.919,4.25a1,1,0,0,0,0,2,2.961,2.961,0,0,1,2.912,3,1,1,0,0,0,2,0A4.962,4.962,0,0,0,14.919,4.25Z', 'M14.685,0a1,1,0,0,0,0,2A7.417,7.417,0,0,1,22,9.5a1,1,0,0,0,2,0A9.42,9.42,0,0,0,14.685,0Z', 'M6.169,9.25a2.961,2.961,0,0,1,2.913-3,1,1,0,0,0,0-2,4.963,4.963,0,0,0-4.913,5,1,1,0,0,0,2,0Z', 'M9.315,2a1,1,0,0,0,0-2A9.42,9.42,0,0,0,0,9.5a1,1,0,0,0,2,0A7.417,7.417,0,0,1,9.315,2Z', 'M18.608,12H13.5a.25.25,0,0,1-.25-.25V9.5a1,1,0,0,0-2,0v2.25A.25.25,0,0,1,11,12H5.892a1,1,0,1,0,0,2H7.167a.25.25,0,0,1,.228.147,20.793,20.793,0,0,0,3.054,4.79.25.25,0,0,1-.022.347,15.541,15.541,0,0,1-4.321,2.8,1,1,0,1,0,.788,1.837,17.606,17.606,0,0,0,4.938-3.2.249.249,0,0,1,.336,0,17.591,17.591,0,0,0,4.938,3.2A.981.981,0,0,0,17.5,24a1,1,0,0,0,.394-1.919,15.5,15.5,0,0,1-4.318-2.8.248.248,0,0,1-.022-.346,20.823,20.823,0,0,0,3.051-4.787A.252.252,0,0,1,16.833,14h1.775a1,1,0,0,0,0-2ZM12.2,17.423a.251.251,0,0,1-.193.091.254.254,0,0,1-.193-.091A19.578,19.578,0,0,1,9.75,14.369.249.249,0,0,1,9.969,14h4.067a.25.25,0,0,1,.22.369A19.384,19.384,0,0,1,12.2,17.423Z']]
};
exports["default"] = _default;